<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-等级管理-添加等级
  -->
  <el-dialog title="添加会员卡" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false" width="600px">
    <el-form size="small" :model="form" ref="form">
      <el-form-item label="会员卡名" :label-width="formLabelWidth" prop="name"
        :rules="[{required: true,message: '请输入会员卡名称'}]">
        <el-input v-model="form.name" placeholder="请输入会员卡名称"></el-input>
      </el-form-item>
      <el-form-item label="时长（天）" :label-width="formLabelWidth" prop="weight"
        :rules="[{required: true,message: '请输入会员卡时长'}]">
        <el-input v-model="form.weight" type="number" placeholder="请输入会员卡时长"></el-input>
        <div class="gray9">-1为永久会员</div>
      </el-form-item>
      <el-form-item label="会员价格" :label-width="formLabelWidth" prop="price"
                    :rules="[{required: true,message: '请输入会员卡价格'}]">
        <el-input v-model="form.price" type="number"step="0.01"  :min="0" autocomplete="off" placeholder="请输入会员卡时长"></el-input>
      </el-form-item>
      <el-form-item label="划线价格" :label-width="formLabelWidth" prop="equity"
        :rules="[{required: true,message: '请输入划线价格'}]">
        <el-input type="number" :precision="1" :step="0.01" :min="0" :max="100" placeholder="请输入划线价格"
          v-model="form.equity">
        </el-input>
      </el-form-item>
      <el-form-item label="描述" :label-width="formLabelWidth" prop="remark" >
        <el-input v-model="form.remark" type="textarea" placeholder="请输入描述"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addGrade()" :disabled="submit_loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {
    data () {
      return {
        form: {
          /*昵称*/
          name: '',
          /*等级折扣*/
          equity: '',
          /*是否打开累计消费满*/
          openMoney: 0,
          /*累计消费满*/
          upgradeMoney: 0,
          /*是否打开累计积分满*/
          openPoints: 0,
          /*累计积分满*/
          upgradePoints: 0,
          /*是否推荐人数满*/
          openInvite: 0,
          /*推荐人数满*/
          upgradeInvite: 0,
          /*等级权重*/
          weight: 1,
          givePoints: 0
        },
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*是否正在提交*/
        submit_loading: false,
      };
    },
    props: ['open_add'],
    created () {
      this.dialogVisible = this.open_add;
    },
    methods: {

      /*添加等级*/
      addGrade () {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.submit_loading = true;
            params.openMoney = params.openMoney == true ? 1 : 0;
            params.openPoints = params.openPoints == true ? 1 : 0;
            params.openInvite = params.openInvite == true ? 1 : 0;
            UserApi.addgrade(params, true).then(data => {
              self.submit_loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible(true);
            })
              .catch(error => {
                self.submit_loading = false;
              });
          }
        });
      },
      /*关闭弹窗*/
      dialogFormVisible (e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }

    }
  };
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/user/grade/part/Add.vue